<template>
  <div>
    <div class="px-4 pb-3">
      <v-btn style="float: right" @click="$emit('close')" icon>
        <v-icon>close</v-icon>
      </v-btn>

      <div style="font-size: 20px; font-weight: 600" class="pt-3 mb-3">
        {{ edittype == 'create' ? 'เพิ่ม' : 'แก้ไข' }}ข้อมูลร้าน
      </div>
      <div class="form-control">
        <v-layout class="pa-0 ma-0" wrap row>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('departmentStore') }"
          >
            <label>{{ $t('รหัสร้านค้า') }}</label>
            <input
              :data-vv-as="$t('รหัสร้านค้า')"
              v-validate="'required'"
              v-model="input.store_id"
              class="form-control"
              type="text"
              name="storeId"
            />
            <span class="text-error" v-if="errors.has('storeId')">{{
              errors.first('storeId')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('storeName') }"
          >
            <label>{{ $t('ชื่อร้านค้า') }}</label>
            <input
              :data-vv-as="$t('ชื่อร้านค้า')"
              v-validate="'required'"
              v-model="input.store_name"
              class="form-control"
              type="text"
              name="storeName"
            />
            <span class="text-error" v-if="errors.has('storeName')">{{
              errors.first('storeName')
            }}</span>
          </v-flex>

          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('storeArea') }"
          >
            <label>{{ $t('พื้นที่') }}</label>
            <input
              :data-vv-as="$t('พื้นที่')"
              v-validate="'required'"
              v-model="input.store_area"
              class="form-control"
              type="text"
              name="storeArea"
            />
            <span class="text-error" v-if="errors.has('storeArea')">{{
              errors.first('storeArea')
            }}</span>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <v-btn @click="$emit('close')" outline color="grey">cancel</v-btn>
          <v-btn :loading="saveloading" @click="savedata" depressed color="primary">save</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: ['edittype', 'editdata'],
  data() {
    return {
      saveloading: false,
      input: {
        id: '',
        store_id: '',
        store_name: '',
        store_area: ''
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    if (this.edittype == 'edit') {
      this.input = {
        id: this.editdata.id,
        store_id: this.editdata.store_id,
        store_name: this.editdata.store_name,
        store_area: this.editdata.store_area
      }
    }
  },
  methods: {
    async savedata() {
      if (await this.$validator.validateAll()) {
        if (this.edittype == 'create') {
          this.createdata()
        } else {
          this.editbranch()
        }
      }
    },
    editbranch() {
      var data = {
        pageid: this.selectedBot.pageid,
        ...this.input,
        campaign_id: this.$store.state.selectToaCampaign
          ? this.$store.state.selectToaCampaign.id
          : null
      }
      this.saveloading = true
      api.updateStoreToaecoupon(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onsave')
        }
      })
    },
    createdata() {
      var data = {
        pageid: this.selectedBot.pageid,
        ...this.input,
        campaign_id: this.$store.state.selectToaCampaign
          ? this.$store.state.selectToaCampaign.id
          : null
      }
      this.saveloading = true
      api.insertStoreToaecoupon(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onsave')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/BranchEdit.vue